import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { AddressDto } from '@/api';
import { addressesApi, StoreResponse, StoreResponses } from '@/stores/api';
import ErrorKey from '@/util/ErrorKey';

@Module({
  namespaced: true,
  name: 'AddressStore',
})
export default class AddressStore extends VuexModule {
  private addressShows: AddressShowDto[] = [];
  private addresses: AddressDto[] = [];

  public get addressShowList(): AddressShowDto[] {
    return this.addressShows;
  }

  public get addressList(): AddressDto[] {
    return this.addresses;
  }

  @Action
  public async fetchAddresses(): Promise<StoreResponse<AddressDto[]>> {
    try {
      const response = await addressesApi.getAllUserAddresses();
      this.context.commit('setAddresses', response.data);
      return StoreResponses.apiSuccess(response);
    } catch (e) {
      return StoreResponses.error(e, ErrorKey.AddressListFetchAction);
    }
  }

  @Action
  public async addAddress(address: AddressDto): Promise<StoreResponse<AddressDto>> {
    try {
      const response = StoreResponses.apiSuccess(await addressesApi.addUserAddress(address));
      if (response.success) {
        const showDto = this.addressShows.find((it) => it.address === address);
        if (showDto) {
          showDto.address = response.payload!;
        } else {
          this.addressShows.push({address: response.payload!, edit: false});
        }
      }
      return response;
    } catch (e) {
      return StoreResponses.error(e, ErrorKey.AddressSaveAction);
    }
  }

  @Action
  public async updateAddress(address: AddressDto): Promise<StoreResponse<AddressDto>> {
    if (!address.id) {
      return StoreResponses.error(null, ErrorKey.WrongAddress);
    }
    try {
      const response = StoreResponses.apiSuccess(await addressesApi.updateUserAddress(address.id, address));
      if (response.success) {
        const showDto = this.addressShows.find((it) => it.address.id === address.id);
        if (showDto) {
          showDto.address = response.payload!;
        }
      }
      return response;
    } catch (e) {
      return StoreResponses.error(e, ErrorKey.AddressSaveAction);
    }
  }

  @Action
  public async deleteUserAddress(id: number): Promise<StoreResponse<Response>> {
    try {
      return StoreResponses.apiSuccess(
        await addressesApi.deleteUserAddress(id),
      );
    } catch (e) {
      return StoreResponses.error(e, ErrorKey.AddressDeleteAction);
    }
  }

  @Mutation
  private setAddresses(addressArray: AddressDto[]) {
    this.addressShows = [];
    this.addresses = addressArray;
    for (const address of addressArray) {
      this.addressShows.push({address, edit: false});
    }
  }
}

export interface AddressShowDto {
  address: AddressDto;
  edit: boolean;
}
